<button class="btn btn-md btn-success" (click)="sendWhatsappMsg($event)">
  <fa-icon [icon]="faWhatsapp" size="lg"></fa-icon>
</button>
&nbsp;
<button class="btn btn-md btn-primary btn-phone" (click)="makeCall($event)">
  <fa-icon [icon]="faPhone" size="lg"></fa-icon>
</button>